"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon-toggle",
    class: {
      "menu-close": !_vm.sidebar.opened
    },
    attrs: {
      id: "div-sidebarButtonToggle"
    },
    on: {
      click: _vm.toggleClick
    }
  }, [_vm._m(0)]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon",
    attrs: {
      id: "div-sidebarButtonToggle-icon"
    }
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/logo.png")
    }
  })]);
}];
render._withStripped = true;